import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import postal from 'postal';
import styled from 'styled-components';
import { scroller } from 'react-scroll';
import IconedButton from '../../shared/iconed-button';
import dt from '../../../shared/theme';

const showContactForm = {
  channel: 'micro-profile.commands',
  topic: 'present-lead-capture-form',
};

const Button = styled(IconedButton)`
  background-color: #6a6e76;

  &:hover {
    background-color: #414651;
    color: white;
  }

  & > span.icon-lw {
    font-size: 16px;
    padding: 5px;
    background-color: ${props => dt(props).theme.bodyColor};
  }
`;

const scrollToName = name => e => {
  e && e.preventDefault();
  scroller.scrollTo(name, {
    // without this offset, the button is at the top edge of the screen,
    // which is underneath the application navbar
    offset: -200,
    duration: 1500,
    smooth: 'easeInOutQuint',
  });
};

export default function ContactButton({ name }) {
  const onMount = () => {
    if (window.location.hash === `#${name}`) {
      scrollToName(name);
    }
  };

  function onClick(e) {
    e && e.preventDefault();

    if (_.get(window, 'Livewire.currentUser.id')) {
      postal.publish(showContactForm);
    } else {
      window.location = `/sign_up?return_to_section=${name}`;
    }
  }

  return (
    <Button name={name} type="button" className="btn" onClick={onClick} ref={onMount}>
      <span className="icon-lw icon-lw-contact" />
      <span>Contact</span>
    </Button>
  );
}

ContactButton.propTypes = { name: PropTypes.string.isRequired };
